import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { Fragment, useRef } from 'react';
import cx from 'classnames';
import useMount from 'react-use/lib/useMount';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';
import { TimelineMax } from 'gsap/TweenMax';
import Button from './Button';
import { config } from '../helpers/config';

var Reveal = function Reveal(_ref) {
  var _onStart = _ref.onStart,
      onReverseStart = _ref.onReverseStart,
      _onComplete = _ref.onComplete,
      _onReverseComplete = _ref.onReverseComplete,
      reveal = _ref.reveal,
      children = _ref.children,
      className = _ref.className,
      trigger = _ref.trigger,
      opts = _objectWithoutPropertiesLoose(_ref, ["onStart", "onReverseStart", "onComplete", "onReverseComplete", "reveal", "children", "className", "trigger"]);

  var triggerRef = useRef();
  var revealRef = useRef();

  var attachTimeline = function attachTimeline() {
    var $reveal = revealRef.current;
    var $trigger = triggerRef.current;
    var forward = true;
    var lastTime = 0; // Attach GSAP

    $reveal.timeline = new TimelineMax({
      paused: true,
      onStart: function onStart() {
        _onStart(); // Set initial height to `auto`


        $reveal.style.height = 'auto'; // Add open class

        $reveal.classList.add(config.classes.open); // Toggle aria state

        $reveal.setAttribute('aria-hidden', false); // Add active class on trigger

        $trigger.classList.add(config.classes.active);
      },
      onUpdate: function onUpdate() {
        var newTime = $reveal.timeline.time();

        if (forward && newTime < lastTime || !forward && newTime > lastTime) {
          forward = !forward;

          if (!forward) {
            onReverseStart(); // Remove active class

            $reveal.classList.remove(config.classes.open); // Toggle aria state

            $reveal.setAttribute('aria-hidden', true); // Remove active class on trigger

            $trigger.classList.remove(config.classes.active);
          }
        }

        lastTime = newTime;
      },
      onComplete: function onComplete() {
        // Allow height to fill-up space
        $reveal.style.height = 'auto';

        _onComplete();
      },
      onReverseComplete: function onReverseComplete() {
        // Set height of content
        $reveal.style.height = '0';

        _onReverseComplete();
      }
    });
    $reveal.timeline.set($reveal, {
      css: {
        display: 'block',
        height: 'auto'
      }
    }).from($reveal, 0.5, {
      css: {
        height: 0,
        opacity: 0
      },
      ease: config.easing
    });

    if (reveal) {
      $reveal.timeline.progress(1);
    }
  };

  var revealOpen = function revealOpen() {
    var $reveal = revealRef.current;
    if ($reveal && $reveal.timeline) $reveal.timeline.play();
  };

  var revealClose = function revealClose() {
    var $reveal = revealRef.current;
    if ($reveal && $reveal.timeline) $reveal.timeline.reverse();
  };

  var handleRevealToggle = function handleRevealToggle() {
    var $reveal = revealRef.current;

    if ($reveal.timeline.progress() === 1) {
      revealClose();
    } else {
      revealOpen();
    }
  };

  useMount(function () {
    attachTimeline();
  });
  useUpdateEffect(function () {
    if (reveal) {
      revealOpen();
    } else {
      revealClose();
    }
  }, [reveal]);
  var classes = cx('reveal-content', className);
  return React.createElement(Fragment, null, React.createElement(Button, Object.assign({
    onClick: handleRevealToggle
  }, trigger.props, {
    ref: triggerRef
  }), trigger.label), React.createElement("div", Object.assign({
    className: "reveal",
    ref: revealRef,
    "aria-hidden": "true"
  }, opts), React.createElement("div", {
    className: classes
  }, children)));
};

Reveal.defaultProps = {
  onComplete: function onComplete() {},
  onReverseComplete: function onReverseComplete() {},
  onReverseStart: function onReverseStart() {},
  onStart: function onStart() {}
};
export default Reveal;